import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import {
  getSchool,
  getSchools,
  createSchool,
  updateSchool,
  deleteSchool,
} from '../api/schools.api';
import { ISchool, IGetSchool, IGetSchools } from '../models/schools.model';

interface ISchoolState {
  school?: ISchool;
  schools?: ISchool[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: ISchoolState = {
  school: undefined,
  schools: [],
  isLoading: false,
};

const schoolSlicer = createSlice({
  name: 'school',
  initialState,
  reducers: {
    getSchoolStart: (state: ISchoolState) => {
      state.school = undefined;
      state.isLoading = true;
      state.error = undefined;
    },
    getSchoolSuccess: (
      state: ISchoolState,
      action: PayloadAction<IGetSchool>,
    ) => {
      state.school = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getSchoolFailure: (
      state: ISchoolState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.school = undefined;
      state.isLoading = false;
      state.error = action.payload;
    },
    getSchoolsStart: (state: ISchoolState) => {
      state.schools = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getSchoolsSuccess: (
      state: ISchoolState,
      action: PayloadAction<IGetSchools>,
    ) => {
      state.schools = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getSchoolsFailure: (
      state: ISchoolState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.schools = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: ISchoolState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (
      state: ISchoolState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: ISchoolState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    updateSuccess: (state: ISchoolState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    deleteSuccess: (state: ISchoolState) => {
      state.isLoading = false;
      state.error = undefined;
    }
  },
});

export const {
  getSchoolsStart,
  getSchoolsSuccess,
  getSchoolsFailure,
  getSchoolStart,
  getSchoolSuccess,
  getSchoolFailure,
  requestStart,
  requestFailure,
  createSuccess,
  updateSuccess,
  deleteSuccess,
} = schoolSlicer.actions;

export default schoolSlicer.reducer;

export const doGetSchool =
  (id: string): any =>
  async (dispatch: any) => {
    try {
      dispatch(getSchoolStart());
      const response = await getSchool(id);
      dispatch(getSchoolSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(getSchoolFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doGetSchools = (): any => async (dispatch: any) => {
  try {
    dispatch(getSchoolsStart());
    const response = await getSchools();
    dispatch(getSchoolsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getSchoolsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateSchool =
  (data: ISchool): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await createSchool(data);
      dispatch(createSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doUpdateSchool =
  (id: string, data: ISchool): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await updateSchool(id, data);
      dispatch(updateSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };


export const doDeleteSchool =
  (schoolCode: number): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await deleteSchool(schoolCode);
      dispatch(deleteSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };